import { useCallback } from 'react'
import { useAppTranslation } from '@hooks/useAppTranslation'
import { useErrorPage } from '@hooks/useErrorPage'

type UseFallbackHandlerReturn = {
  handleRestricted: () => void
  handleNoEligibleProducts: () => void
  showErrorPage: () => void
}

export const useFallbackHandler = (): UseFallbackHandlerReturn => {
  const { t } = useAppTranslation({ keyPrefix: 'start-redirect' })
  const { showErrorPage } = useErrorPage()

  const handleRestricted = useCallback(() => {
    const title = t('restricted.title')
    const message = t('restricted.message')
    showErrorPage({ contentOptions: { title, message } })
  }, [t, showErrorPage])

  const handleNoEligibleProducts = useCallback(() => {
    const title = t('ineligible-cart.title')
    const message = t('ineligible-cart.message')
    showErrorPage({ contentOptions: { title, message } })
  }, [t, showErrorPage])

  return {
    handleNoEligibleProducts,
    handleRestricted,
    showErrorPage,
  }
}
